module Meevo.Plugins.AlertsManager {

    class MeevoNoConfigComponent implements ng.IComponentController {

        static $inject = [];

        public params: IParams;

        constructor() {
            Object.defineProperties(this.params, {
                dataForReview: {
                    get: () => []
                },
                alertConfigurations: {
                    get: () => []
                }
            });
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoNoConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/no-config/no-config.component.html',
            controller: MeevoNoConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}
